import React, { useState } from "react";
import API_URL from "../component/config";
import axios from "axios";
import {
  ErrorNotification,
  SuccessNotification,
} from "../tosterNotification/tosters";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
export default function Login() {
  const [formData, setFormData] = useState({
    email_id: "",
    password: "",
  });
  const navigate = useNavigate();
  // const [rememberDevice, setRememberDevice] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/api/admin/login`, formData);

      if (response.data.success) {
        throw new Error(response.message || "Login failed");
      }

      localStorage.setItem("adminId", response.data.data.admin_id);
      localStorage.setItem("adminToken", response.data.data.token);
      localStorage.setItem("role", response.data.data.role);
      console.log(response.data);
      SuccessNotification("Login Successful");
      if (response.data.data.role !== "admin") {
        navigate("/leads");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(err.message);
      ErrorNotification(err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <div id="main-wrapper" className="auth-customizer-none">
        <div className="position-relative overflow-hidden radial-gradient min-vh-100 w-100">
          <div className="position-relative z-index-5">
            <div className="row">
              <div className="col-xl-7 col-xxl-8">
                <div className="d-none d-xl-flex align-items-center justify-content-center h-n80">
                  <img
                    src="../../assets/assets/images/backgrounds/login-security.svg"
                    alt="modernize-img"
                    className="img-fluid"
                    width={500}
                  />
                </div>
              </div>
              <div className="col-xl-5 col-xxl-4">
                <div className="authentication-login min-vh-100 bg-body row justify-content-center align-items-center p-4">
                  <div className="auth-max-width col-sm-8 col-md-6 col-xl-7 px-4">
                    <h2 className="mb-1 fs-7 fw-bolder">
                      Welcome to Clif Admin
                    </h2>
                    <p className="mb-7">Your Admin Dashboard</p>

                    <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                      {/* {error && (
                        <div className="mb-4 p-3 text-sm text-red-500 bg-red-100 rounded">
                          {error}
                        </div>
                      )} */}

                      <div className="mb-3">
                        <label htmlFor="email_id" className="form-label">
                          Username
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email_id"
                          name="email_id"
                          value={formData.email_id}
                          onChange={handleInputChange}
                          aria-describedby="emailHelp"
                          required
                        />
                      </div>

                      <div className="mb-4 position-relative">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          required
                        />
                        <div
                          className="position-absolute top-50 end-0 me-2"
                          onClick={() => {
                            setShowPassword(!showPassword);
                            console.log(showPassword);
                          }}
                        >
                          {showPassword ? <EyeOff /> : <Eye />}
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-8 mb-4 rounded-2"
                        disabled={loading}
                      >
                        {loading ? "Signing In..." : "Sign In"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
